import axios from '@/libs/api.request';

export const getPreSaleDistributionStationDeliveryDetail = (preSaleOrderRecordUuid, deliveryUuid) => {
    return axios.request({
        url: 'api/distributionStationProductStore/delivery/getPreSaleDistributionStationDeliveryDetail',
        data: { preSaleOrderRecordUuid, deliveryUuid },
        method: 'post'
    });
};

export const printPreSaleDistributionStationDeliveryDetail = preSaleOrderRecordUuid => {
    return axios.request({
        url: 'api/distributionStationProductStore/delivery/printPreSaleDistributionStationDeliveryDetail',
        data: { preSaleOrderRecordUuid },
        method: 'post'
    });
};

export const saveCurSaleDeliveryFee = data => {
    return axios.request({
        url: 'api/distributionStationProductStore/delivery/saveCurSaleDeliveryFee',
        data: data,
        method: 'post'
    });
};

export const savePreSaleDeliveryFee = data => {
    return axios.request({
        url: 'api/distributionStationProductStore/delivery/savePreSaleDeliveryFee',
        data: data,
        method: 'post'
    });
};


export const savePreSaleDistributionStationDelivery = data => {
    return axios.request({
        url: 'api/distributionStationProductStore/delivery/savePreSaleDistributionStationDelivery',
        data: data,
        method: 'post'
    });
};

export const getCurSaleDistributionStationDeliveryDetail = curSaleOrderRecordUuid => {
    return axios.request({
        url: 'api/distributionStationProductStore/delivery/getCurSaleDistributionStationDeliveryDetail',
        data: { curSaleOrderRecordUuid },
        method: 'post'
    });
};

export const printCurSaleDistributionStationDeliveryDetail = curSaleOrderRecordUuid => {
    return axios.request({
        url: 'api/distributionStationProductStore/delivery/printCurSaleDistributionStationDeliveryDetail',
        data: { curSaleOrderRecordUuid },
        method: 'post'
    });
};


export const saveCurSaleDistributionStationDelivery = data => {
    return axios.request({
        url: 'api/distributionStationProductStore/delivery/saveCurSaleDistributionStationDelivery',
        data: data,
        method: 'post'
    });
};

export const getDistributionStationDeliveryList = data => {
    return axios.request({
        url: 'api/distributionStationProductStore/delivery/getDistributionStationDeliveryList',
        data: data,
        method: 'post'
    });
};
